// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimilarSection_container__93yHr {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 12px;
  }
  
  .SimilarSection_headerContainer__50oDp {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 8px;
  }
  
  .SimilarSection_title__dTS\\+1 {
    color: white;
    font-size: 24px;
    margin: 0;
  }
  
  .SimilarSection_viewAll__UTCXk {
    color: white;
    text-decoration: none;
    font-size: 14px;
    padding: 8px 12px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }
  
  .SimilarSection_viewAll__UTCXk:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .SimilarSection_scrollContainer__1W6im {
    position: relative;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-behavior: smooth;
    padding: 0 8px;
  }
  
  .SimilarSection_scrollContainer__1W6im::-webkit-scrollbar {
    display: none;
  }
  
  .SimilarSection_seriesGrid__QXLT6 {
    display: flex;
    gap: 16px;
    padding: 20px 0;
    min-width: min-content;
  }
  
  .SimilarSection_seriesItem__2A28s {
    position: relative;
    flex-shrink: 0;
    cursor: pointer;
    transition: transform 0.3s ease;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .SimilarSection_seriesItem__2A28s:hover {
    transform: scale(1.05);
  }
  
  .SimilarSection_seriesImage__IKZE4 {
    width: auto;
    max-width: 300px;
    height: 300px;
    object-fit: cover;
  }
  
  .SimilarSection_progressBar__UmLQy {
    position: relative;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    margin: 16px 8px 0;
  }
  
  .SimilarSection_progressIndicator__5HCmt {
    position: absolute;
    height: 100%;
    background-color: rgb(255, 0, 0);
    border-radius: 2px;
    transition: width 0.3s ease;
  }
  
  /* Responsive styles */
  @media (max-width: 1200px) {
    .SimilarSection_container__93yHr {
      margin: 0 16px;
    }
  }
  
  @media (max-width: 768px) {
    .SimilarSection_seriesImage__IKZE4 {
      width: 160px;
      height: 240px;
    }
    
    .SimilarSection_title__dTS\\+1 {
      font-size: 20px;
    }
    
    .SimilarSection_container__93yHr {
      margin: 0 12px;
      padding: 16px;
    }
  }
  
  @media (max-width: 480px) {
    .SimilarSection_seriesImage__IKZE4 {
      width: 140px;
      height: 210px;
    }
    
    .SimilarSection_title__dTS\\+1 {
      font-size: 18px;
    }
    
    .SimilarSection_container__93yHr {
      margin: 0 8px;
      padding: 12px;
    }
    
    .SimilarSection_seriesGrid__QXLT6 {
      gap: 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/EpisodeScreen/Component/CSS/SimilarSection.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA,sBAAsB;EACtB;IACE;MACE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,cAAc;MACd,aAAa;IACf;EACF;;EAEA;IACE;MACE,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,aAAa;IACf;;IAEA;MACE,SAAS;IACX;EACF","sourcesContent":[".container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    border-radius: 12px;\n  }\n  \n  .headerContainer {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    padding: 0 8px;\n  }\n  \n  .title {\n    color: white;\n    font-size: 24px;\n    margin: 0;\n  }\n  \n  .viewAll {\n    color: white;\n    text-decoration: none;\n    font-size: 14px;\n    padding: 8px 12px;\n    border-radius: 4px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .viewAll:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  .scrollContainer {\n    position: relative;\n    overflow-x: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    scroll-behavior: smooth;\n    padding: 0 8px;\n  }\n  \n  .scrollContainer::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .seriesGrid {\n    display: flex;\n    gap: 16px;\n    padding: 20px 0;\n    min-width: min-content;\n  }\n  \n  .seriesItem {\n    position: relative;\n    flex-shrink: 0;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  \n  .seriesItem:hover {\n    transform: scale(1.05);\n  }\n  \n  .seriesImage {\n    width: auto;\n    max-width: 300px;\n    height: 300px;\n    object-fit: cover;\n  }\n  \n  .progressBar {\n    position: relative;\n    height: 4px;\n    background-color: rgba(255, 255, 255, 0.2);\n    border-radius: 2px;\n    margin: 16px 8px 0;\n  }\n  \n  .progressIndicator {\n    position: absolute;\n    height: 100%;\n    background-color: rgb(255, 0, 0);\n    border-radius: 2px;\n    transition: width 0.3s ease;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 1200px) {\n    .container {\n      margin: 0 16px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .seriesImage {\n      width: 160px;\n      height: 240px;\n    }\n    \n    .title {\n      font-size: 20px;\n    }\n    \n    .container {\n      margin: 0 12px;\n      padding: 16px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .seriesImage {\n      width: 140px;\n      height: 210px;\n    }\n    \n    .title {\n      font-size: 18px;\n    }\n    \n    .container {\n      margin: 0 8px;\n      padding: 12px;\n    }\n    \n    .seriesGrid {\n      gap: 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SimilarSection_container__93yHr`,
	"headerContainer": `SimilarSection_headerContainer__50oDp`,
	"title": `SimilarSection_title__dTS+1`,
	"viewAll": `SimilarSection_viewAll__UTCXk`,
	"scrollContainer": `SimilarSection_scrollContainer__1W6im`,
	"seriesGrid": `SimilarSection_seriesGrid__QXLT6`,
	"seriesItem": `SimilarSection_seriesItem__2A28s`,
	"seriesImage": `SimilarSection_seriesImage__IKZE4`,
	"progressBar": `SimilarSection_progressBar__UmLQy`,
	"progressIndicator": `SimilarSection_progressIndicator__5HCmt`
};
export default ___CSS_LOADER_EXPORT___;
